// Dependencias
import DataTable, { Api } from 'datatables.net-bs5';
import Swal from 'sweetalert2';
import { AxiosError } from 'axios';

// Config
import { generalConfig } from '../config/datatable.config';
import { alertConfigurations } from '../config/sweetAlert.config';
import { GenericMessage, OptionsMessages } from '../config/Messages.config';

// Servicios
import { 
  KiuberStatus,
  KiuberRoles,
  getAllKibers,
  Kiuber,
  getKiuberById,
  activeOrBlockKiuber,
  setRoleKiuber,
  createKiuber
} from '../service/kiuber.service';
import { getClientDetails,ClientWHMCS, HttpResponse as HttpResponseWhmcs } from '../service/whmcs.service';

// Utils
import {
  ValidationsTypes,
  validInputStyle,
  validationInputs
} from '../utils/stylesInputs';
import { loadLoader } from '../utils/loader';
import { drawActiveKiuber, drawEditButomKiuber, drawRoleKiuber, drawTable } from '../utils/drawTable';
import { randomPassword } from '../utils/randomPassword';


// Elementos HTML
const kiubersListElement = document.querySelector<HTMLTableElement>('#kiubersList')!;
const formSearch = document.querySelector<HTMLFormElement>('#form-search')!;
const selectSearch = document.querySelector<HTMLSelectElement>('#selectSearch')!;
const foliosTable = document.querySelector<HTMLTableElement>('#folios-asing')!;
const addFoliosElement = document.querySelector<HTMLButtonElement>('#button-add-folios')!;
const addKiuber = document.querySelector<HTMLButtonElement>('#button-add-kiuber')!;

// Variables globales
let kiubersListTable: Api<string[]>;
let foliosListTable: Api<string[]>;
let currentPage = 1;
let lengthTable = 10;
const currentPageFolios = 1;
const eventsInputsToValid = ['keyup', 'change', 'focusout'];

/**
 *
 */
export function main() {
  document.addEventListener('DOMContentLoaded', () => {
    Promise.all([
      // Configuraciones de DataTable para Kiubers
      (() => {
        kiubersListTable = new DataTable(kiubersListElement, generalConfig);
        kiubersListTable.on('draw', async() => {
          const info = kiubersListTable.page.info();

          // Si la Pagina no es mayor a los datos establecidos, sale de la función
          if (!(info.page + 1 > currentPage)) return;

          // Se obtienen los filtros del formulario
          const json = Object.fromEntries(
            new FormData(formSearch)
          ) as ParamsSearch;
          currentPage = info.page + 1;

          loadLoader({});
          const kiubersList = await getAllKibers({ 
            params: {
              [json.selectSearch]: json.valueToSearch,
              page: currentPage + 1,
              limit: lengthTable
            }
          })!;
          drawTable({
            table: kiubersListTable,
            data: kiubersList,
            addFinale: true,
            format: formatKiuberTable
          });
          loadLoader({ start: false });
        });
        kiubersListTable.on('length', (_, __, len) =>  {
          lengthTable = len;
          // DataTable re-pagina automáticamente con los datos ya cargados, no se necesita nueva llamada a la API
        });
      })(),
      addListenerEditButtomKiuber(),
      // Configuraciones de animaciones de CSS
      (async() => {
        const { main } = await import('../partials/setting-styles');
        main();
      })(),
      // Configuración para asignación de folios
      (() => {
        foliosListTable = new DataTable(foliosTable, {
          ...generalConfig,
          pageLength: 9
        });
      })()
    ]);
  });

  formSearch.addEventListener('submit',async(e) => {
    e.preventDefault();

    // Se obtienen los filtros del formulario
    const json = Object.fromEntries(
      new FormData(formSearch)
    ) as ParamsSearch;

    currentPage = 1;
    loadLoader({});
    const kiubersList = await getAllKibers({ 
      params: {
        [json.selectSearch]: json.valueToSearch,
        limit: 0
      }
    })!;
    drawTable({
      table: kiubersListTable,
      data: kiubersList,
      format: formatKiuberTable
    });
    addListenerEditButtomKiuber();
    loadLoader({ start: false });
  });

  selectSearch.addEventListener('change', (e) => {
    // Se realizan procesos en paralero, para evitar el uso de 2 eventos del mismo tipo
    Promise.all([
      // Proceso para ejecutar si la opción elejida por el input es correcta
      (() => {
        const container = selectSearch.parentElement as HTMLDivElement;
        const input = selectSearch;
        
        validInputStyle({
          type: ValidationsTypes.VALID,
          container,
          input
        });
      })(),
      // Proceso para cambir el input de opcion o cambio de elemento HTML
      (() => {
        const target = e.target as HTMLInputElement;
        const [containerInput] = formSearch.children[1].children;
        const [elementToRemove] = containerInput.children;
        const inputToChange = formSearch.querySelector('input')!;
        const isStatusOption = target.value === TypeInputOptions.STATUS;
        const isRoleOption = target.value === TypeInputOptions.ROLE;

        // Se crea el elemento Select para los datos
        let isFirstElement = true;
        console.log(target.value, TypeInputOptions.STATUS);
        if (isStatusOption) {
          
          const selectOptions = document.createElement('select');
          const innerElements = ['Seleccione una opción','hr','Activo', 'Inactivo'].map((value, index)=> {
            if (value === 'hr') return document.createElement('hr');
            const option = document.createElement('option');
            if (isFirstElement) {
              option.value = '';
              option.disabled = true;
              option.selected = true;
              isFirstElement = false;
            }
            if ([2,3].includes(index)) 
              option.value =
                index === 2
                  ? KiuberStatus.ACTIVE
                  : KiuberStatus.INACTIVE;
            option.text = value;
            return option;
          });

          selectOptions.id = 'inputSearch';
          selectOptions.append(...innerElements);
          selectOptions.classList.add('form-select', 'text-black-50');
          selectOptions.name = 'valueToSearch';
          selectOptions.required = true;

          // Se agrega el evento de validacion de inputs
          eventsInputsToValid.forEach((event) =>
            selectOptions.addEventListener(event, (e) => validationInputs({ e }))
          );
          
          elementToRemove.remove();
          containerInput.append(selectOptions);

          return;
        }

        if (isRoleOption) {
          const selectOptions = document.createElement('select');
          const labelOptions =  ['Seleccione una opción','hr','Administrador', 'Soporte', 'Ventas', 'Ninguno'];
          const innerElements = labelOptions.map((value, index)=> {
            if (value === 'hr') return document.createElement('hr');
            const option = document.createElement('option');
            if (isFirstElement) {
              option.value = '';
              option.disabled = true;
              option.selected = true;
              isFirstElement = false;
            }
            if ([2,3,4,5].includes(index))  {
              if (index === 2) option.value = KiuberRoles.ADMIN;
              else if (index === 3) option.value = KiuberRoles.SQUAD;
              else if (index === 4) option.value = KiuberRoles.SALES;
              else option.value = KiuberRoles.NONE;
            }
            option.text = value;
            return option;
          });

          selectOptions.id = 'inputSearch';
          selectOptions.append(...innerElements);
          selectOptions.classList.add('form-select', 'text-black-50');
          selectOptions.name = 'valueToSearch';
          selectOptions.required = true;

          // Se agrega el evento de validacion de inputs
          eventsInputsToValid.forEach((event) =>
            selectOptions.addEventListener(event, (e) => validationInputs({ e }))
          );
          
          elementToRemove.remove();
          containerInput.append(selectOptions);

          return;
        }

        if (inputToChange) {
          const isAllOption = target.value === TypeInputOptions.ALL;
          inputToChange.value = isAllOption ? '' : inputToChange.value;
          inputToChange.classList.remove('is-invalid', 'is-valid');
          inputToChange.disabled = isAllOption;
          return;
        }
        
        // Se crea el input si Existe el Select para cambio de datos
        const createdInput = document.createElement('input');
        createdInput.required = true;
        createdInput.type = 'text';
        createdInput.name = 'valueToSearch';
        createdInput.placeholder = 'Buscar';
        createdInput.classList.add('form-control', 'text-black-50');

        eventsInputsToValid.forEach((event) =>
          createdInput.addEventListener(event, (e) =>
            validationInputs({ e })
          )
        );
        
        // Se remueve el elmento y se añada al contenedor
        elementToRemove.remove();
        containerInput.appendChild(createdInput);

        // Si elije la opcion de Todos los usuarios se desabilita el input
        createdInput.disabled = target.value === TypeInputOptions.ALL;
      })()
    ]);
  });

  addKiuber.addEventListener('click', async() => {
    try {
      const { value: kiuber } = await Swal.fire<ClientWHMCS>({
        ...alertConfigurations,
        allowEscapeKey: false,
        heightAuto: true,
        showDenyButton: false,
        confirmButtonText: OptionsMessages.ACEPTAR,
        icon: 'question',
        text: 'Ingresa el ID del Kiuber del Sistema WHMCS (idclient)',
        input: 'number' as any,
        showLoaderOnConfirm: true,
        inputAttributes: {
          autocapitalize: 'off',
          min: '1'
        },
        preConfirm: async(id) => {
          if (!id || id <= 0) {
            Swal.showValidationMessage('El ID del Kiuber es obligatorio');
            return;
          }
          
          try {
            const clientDetails = await getClientDetails(id);
            return { ...clientDetails.client, idclient: id };
          } catch (error) {
            if (error instanceof AxiosError) {
              const { response } = error as AxiosError<HttpResponseWhmcs<ClientWHMCS>>;
              const { message } = response!.data;

              Swal.showValidationMessage(message);
              return;
            }
          }
        },
        allowOutsideClick: () => !Swal.isLoading()
      });

      // Si no se encuentra el kiuber en WHMCS, se sale del proceso
      if (!kiuber) return;

      const result = await Swal.fire({
        ...alertConfigurations,
        allowEscapeKey: false,
        heightAuto: true,
        confirmButtonText: OptionsMessages.ACEPTAR,
        denyButtonText: OptionsMessages.CANCELAR,
        titleText: 'INFORMACIÓN',
        html: `
          <div class="mb-3">
            <p class="fs-5"><span class="fw-bold">Nombre:</span> ${kiuber.nombre} ${kiuber.apellidos}</p>
            <p class="fs-5"><span class="fw-bold">Correo Electronico:</span> ${kiuber.email}</p>
          </div>
          <div class="mb-3">
            <select class="form-select text-black-50" require name="role" id="new-role">
              <option value="" selected disabled="">Seleccione una Rol</option>
              <hr>
              <option value="Admin">Administrador</option>
              <option value="Squad">Soporte</option>
              <option value="Ventas">Ventas</option>
              <option value="None">Ninguno</option>
            </select>
          </div>
          <div class="mb-3">
            <select class="form-select text-black-50" name="active" required id="new-status">
              <option value="" selected disabled="">Seleccione el Estatus</option>
              <hr>
              <option value="1">Activo</option>
              <option  value="0">Inactivo</option>
            </select>
          </div>
        `,
        didOpen: () => {
          const newRole = document.querySelector<HTMLSelectElement>('#new-role')!;
          const newStatus = document.querySelector<HTMLSelectElement>('#new-status')!;

          [newRole, newStatus].forEach(input => {
            input.addEventListener('change', () => {
              const container = input.parentElement as HTMLDivElement;

              validInputStyle({
                type: ValidationsTypes.VALID,
                container,
                input
              });
            });
          });
        },
        preConfirm: () => {
          const newRole = document.querySelector<HTMLSelectElement>('#new-role')!;
          const newStatus = document.querySelector<HTMLSelectElement>('#new-status')!;

          if (newRole.value === '' || newStatus.value === '') {
            
            [newRole, newStatus].forEach((input) => {
              if (input.value === '') {
                const container = input.parentElement as HTMLDivElement;

                validInputStyle({
                  type: ValidationsTypes.INVALID,
                  container,
                  input
                });
                return;
              }
            });

            Swal.showValidationMessage('Seleccione todos los campos');
            return;
          }

          let dataKiuber =  [newRole, newStatus].reduce(
            (object, input) => ({ ...object, [input.name]: input.value }),
            {}
          );

          dataKiuber = { 
            ...dataKiuber,
            ...kiuber
          };

          return dataKiuber;
        }
      });

      // Se termina el proceso si no se agrega un nuevo kiuber
      if (result.isDenied || result.isDismissed) return;

      // Se añade el nuevo kiuber
      loadLoader({ topScroll: window.scrollY });

      const newKiuber = {
        name: result.value!.nombre!,
        last_name: result.value!.apellidos!,
        email: result.value!.email!,
        password: randomPassword({ length: 20 }),
        lang: 'es',
        phone: result.value!.telefono!,
        countryCallingCode: '+52',
        equipo: 'Windows',
        country: 'México',
        clientIdWHMCS: result.value!.idclient
      };

      // Se guarda el nuevo kiuber en la base de datos
      const { userId } = await createKiuber(newKiuber);

      await Promise.all([
        setRoleKiuber({ params: { id: userId, role: result.value!.role } }),
        activeOrBlockKiuber({ params: { id: userId, active: result.value!.active } })
      ]);

      loadLoader({ start: false, topScroll: window.scrollY });

      // Se mustran las credenciales del nuevo kiuber
      await Swal.fire({
        ...alertConfigurations,
        icon: 'success',
        title: 'KIUBER CREADO',
        html: `
          <div class="mb-3 text-start">
            <hr>
            <p class="mb-1"><span class="fw-bold">
              Correo Electrónico: <br> </span> ${newKiuber.email} 
              <button class="btn btn-outline-secondary btn-sm rounded" data-clipboard-text="${newKiuber.email}"><i class="bi bi-clipboard"></i></button>
            </p>
            <p class="mb-1">
              <span class="fw-bold">Contraseña: <br> </span> ${newKiuber.password}
              <button class="btn btn-outline-secondary btn-sm rounded" data-clipboard-text="${newKiuber.password}"><i class="bi bi-clipboard"></i></button>
            </p>
          </div>
          <div class="mb-3 text-start">
            <p class="mb-1">Es importante que el kiuber cambie su contraseña en el primer inicio de sesión.</p>
          </div>
        `,
        showConfirmButton: true,
        confirmButtonText: OptionsMessages.ACEPTAR,
        showDenyButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          const buttonsClipboard = Swal.getHtmlContainer()!.querySelectorAll('button');
          buttonsClipboard.forEach(button => button.addEventListener('click', copyToClipboard));
        },
        willClose: () => {
          const buttonsClipboard = Swal.getHtmlContainer()!.querySelectorAll('button');
          buttonsClipboard.forEach(button => button.removeEventListener('click', copyToClipboard));
        }
      });

      // Se recarga la página para actualizar la tabla
      window.location.reload();
    } catch (error) {
      loadLoader({ start: false, topScroll: window.scrollY });
      if (error instanceof AxiosError) {
        const { status, data } = error.response!;
      
        Swal.fire({
          ...alertConfigurations,
          icon: 'error',
          title: status === 400 ? 'ERROR DE VALIDACIÓN' : GenericMessage.ERROR,
          text: data.message,
          showConfirmButton: true,
          showDenyButton: false
        });
        return;
      } 

      console.error(error);
    }
  });
};

/**
 *
 */
function addListenerEditButtomKiuber() {
  kiubersListElement.removeEventListener('click', editButtomKiuber, { capture: true });
  kiubersListElement.addEventListener('click', editButtomKiuber, { capture: true });
}

/**
 *
 * @param e
 * @returns
 */
async function editButtomKiuber(e: Event) {
   const targetElement = e.target as HTMLElement;

  // Si no son Elementos Button o I, se salen del manejador de eventos
  if (!(targetElement.tagName in TypeElementClicked)) return;

  // Se obtiene el id del cliente.
  const id = Number(
    targetElement.tagName === TypeElementClicked.I
      ? targetElement.parentElement?.dataset.id
      : targetElement.dataset.id
  );

  loadLoader({ topScroll: window.scrollY });
  const kiuber = await getKiuberById({ params: { id } });
  loadLoader({ start: false });

  const result = await Swal.fire<{ role: KiuberRoles; active: '1' | '0' }>({
    ...alertConfigurations,
    allowEscapeKey: false,
    heightAuto: true,
    confirmButtonText: OptionsMessages.ACEPTAR,
    denyButtonText: OptionsMessages.CANCELAR,
    titleText: 'INFORMACIÓN',
    html: `
      <div class="mb-3">
        <p class="fs-5"><span class="fw-bold">Nombre:</span> ${kiuber?.fullname}</p>
        <p class="fs-5"><span class="fw-bold">Correo Electronico:</span> ${kiuber?.email}</p>
      </div>
      <div class="mb-3">
        <select class="form-select text-black-50" require name="role" id="new-role">
          <option value="" disabled="">Seleccione una Rol</option>
          <hr>
          <option ${kiuber?.role === KiuberRoles.ADMIN && 'selected'} value="Admin">Administrador</option>
          <option ${kiuber?.role === KiuberRoles.SQUAD && 'selected'} value="Squad">Soporte</option>
          <option ${kiuber?.role === KiuberRoles.SALES && 'selected'} value="Ventas">Ventas</option>
          <option ${kiuber?.role === null && 'selected'} value="None">Ninguno</option>
        </select>
      </div>
      <div class="mb-3">
        <select class="form-select text-black-50" name="active" required id="new-status">
          <option value="" disabled="">Seleccione el Estatus</option>
          <hr>
          <option ${`${kiuber!.active}` === KiuberStatus.ACTIVE && 'selected'} value="1">Activo</option>
          <option ${`${kiuber!.active}` === KiuberStatus.INACTIVE && 'selected'} value="0">Inactivo</option>
        </select>
      </div>
    `,
    preConfirm: () => {
      const newRole = document.querySelector<HTMLSelectElement>('#new-role')!;
      const newStatus = document.querySelector<HTMLSelectElement>('#new-status')!;
      
      return [newRole, newStatus].reduce(
        (object, input) => ({ ...object, [input.name]: input.value }),
        {}
      );
    }
  });

  // Salgo de la funcion si cancelo el proceso de edicion del kiuber
  if (result.isDismissed || result.isDenied) return;

  loadLoader({ topScroll: window.scrollY });
  Promise.all([
    activeOrBlockKiuber({ params: { id, active: result.value!.active } }),
    setRoleKiuber({ params: { id, role: result.value!.role } })
  ]);
  
  await Swal.fire({
    ...alertConfigurations,
    icon: 'success',
    title: GenericMessage.SUCCESS,
    showConfirmButton: false,
    showDenyButton: false,
    timer: 1000
  });
  loadLoader({ start: false, topScroll: window.scrollY });
  window.location.reload();
}

/**
 *
 * @param data
 * @returns
 */
function formatKiuberTable(data: Kiuber[]) {
  const editedData = data.map(({ id, active, email, fullname, role }) => 
    Object.values({
      id,
      fullname,
      email,
      role: drawRoleKiuber(role),
      active: drawActiveKiuber(active),
      actions: drawEditButomKiuber(id)
    })
  );

  return editedData;
}

/**
 * 
 * @param button 
 */
function copyToClipboard(e: Event) {
  e.preventDefault();

  const button = e.currentTarget as HTMLButtonElement;
  const clipboardText = button.getAttribute('data-clipboard-text');
  if (clipboardText) {
    navigator.clipboard.writeText(clipboardText);
  }
}


// Definicion de tipos e interfaces
type ParamsSearch = {
  selectSearch: string;
  valueToSearch: string;
};
enum TypeInputOptions {
  ALL = 'all',
  ID = 'id',
  EMAIL = 'email',
  STATUS = 'active',
  NAME = 'name',
  ROLE = 'role'
}
enum TypeElementClicked {
  BUTTON = 'BUTTON',
  I = 'I',
}